import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useReactToPrint } from "react-to-print";

const headerStyle = {
  p: 1,
  textAlign: "center",
  bgcolor: "#4527a0",
  color: "#FFF",
};
const cellStyle = {
  p: 0.5,
  textAlign: "center",
  border: "1px solid black",
};
function SalesReportPrint() {
  const { companyInfo } = useSelector((state) => state?.common);
  const logo = JSON.parse(companyInfo?.logo);
  const location = useLocation();
  const tabledata = location.state;
  const navigate = useNavigate();
  const componentRef = useRef();

  const columns = [
    // {
    //   headerName: "SINO",
    // },
    { headerName: "Date" },
    { headerName: "BillNo" },
    { headerName: "Customer Name" },
    { headerName: "Sub-Total" },
    { headerName: "Disc" },
    { headerName: "Tax" },
    { headerName: "Total Amt" },
  ];

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      navigate(-2);
    },
  });
  useEffect(() => {
    handlePrint();
  }, [handlePrint]);
  return (
    <div ref={componentRef}>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box px={2}>
          <Box
            component={"img"}
            sx={{ height: 140, width: 140 }}
            src={logo?.img}
          />
        </Box>
        <Box>
          <Typography variant="h2" fontWeight={"bold"}>
            Sales Report
          </Typography>
        </Box>
        <Box px={2}>
          <Stack>
            <Typography textAlign={"center"} variant="h3">
              {companyInfo?.Name}
            </Typography>
            <Typography
              textAlign={"center"}
              variant="h5"
            >{`${companyInfo?.Add1} ${companyInfo?.Add2}`}</Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.Ph}
            </Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.city_name}
            </Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.Place}
            </Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.EMail}
            </Typography>
          </Stack>
        </Box>
      </Stack>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {columns?.map((data, idx) => {
                return (
                  <TableCell sx={headerStyle} key={idx}>
                    {data.headerName}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {tabledata.map((data, idx) => (
              <TableRow key={idx}>
                {/* <TableCell sx={cellStyle}>{idx + 1}</TableCell> */}
                <TableCell sx={cellStyle}>{data?.BillDate}</TableCell>
                <TableCell sx={cellStyle}>{data?.BillNo}</TableCell>
                <TableCell sx={cellStyle}>{data?.BillPartyName}</TableCell>
                <TableCell sx={cellStyle}>{data?.BillTotalField}</TableCell>
                <TableCell sx={cellStyle}>{data?.BillDiscAmtField}</TableCell>
                <TableCell sx={cellStyle}>{data?.TaxAmt}</TableCell>
                <TableCell sx={cellStyle}>{data?.BillNetTotalField}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default SalesReportPrint;
